angular.module('core')
  .controller('ExportController', ['$scope', 'configuration', function($scope, $configuration) {
    $scope.exportSectionVisible = $configuration.isExportSectionVisible();
  }])
.directive('exportSection', [function () {
    return {
      restrict: 'E',
      scope: {
        exportUrl: '=',
        buttonTitle: '@',
        dblAnalyticsLabel: '@',
        dblAnalyticsEvent: '@'
      },
      controller: 'ExportController',
      templateUrl: '/resources/core/partials/export-section.html',
      link: function($scope, $element, $attr) {

      }
    };
  }]);
